import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const styles = ({ theme }) => ({
  root: {
    maxWidth: ({ width }) => width,
    marginBottom: theme.margin.sm
  },
  img: {
    width: '100%',
    lineHeight: 0
  }
});

const ImageField = ({ classes, src, alt }) => (
  <div className={classes.root}>
    <img className={classes.img} src={src} alt={alt} />
  </div>
);

ImageField.defaultProps = {
  width: '100%'
};

ImageField.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.string
};

export default injectSheet(styles)(ImageField);
